import { gql } from "@apollo/client";

export const CREATE_EXCEPTION_FOR_SCOPES = gql`
  mutation CreateExceptionForScopes($input: ApplyExceptionForScopesInput!) {
    applyExceptionForScopes(input: $input)
  }
`;
